var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSynpulse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000011006349959041573470000015326818415710809009_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F37321;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.1,377.9l35.8-41.6c24.7,23.2,57.9,38.9,89.4,38.9c38.9,0,60-17.4,60-44.2c0-28.4-22.1-37.3-53.1-50.5 L210.9,260c-33.7-14.2-69.4-41.1-69.4-91.5c-0.1-54.7,48.3-96.8,115.7-96.8c40,0,78.9,16.8,105.7,43.7l-31.1,38.9 c-22.1-18.4-45.2-29.4-74.7-29.4c-32.6,0-54.2,15.3-54.2,40.5c0,26.8,26.3,36.8,54.7,48.4l46.8,19.4c40.5,17.4,69.4,43.2,69.4,93.2 c0,55.7-46.3,102.1-123.6,102.1C203.9,428.3,158.7,409.9,126.1,377.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynpulse);
export default __webpack_public_path__ + "static/media/Synpulse.843c4753f23427af414650ba1e763b08.svg";
export { ForwardRef as ReactComponent };